/**
 * FF Marquee — seamless infinite loop
 * Only measures width and sets CSS shift. Never modifies item content.
 */
(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initMarquee(root) {
    if (!root) return;

    const track = root.querySelector('.ff-marquee__track');
    const groups = track ? [...track.querySelectorAll('.ff-marquee__group')] : [];
    const template = groups[0];
    if (!track || !template) return;

    groups.slice(2).forEach((group) => group.remove());

    if (REDUCED_MOTION.matches || window.Shopify?.designMode) {
      root.setAttribute('data-paused', '');
      root.style.removeProperty('--ff-marquee-shift');
      return;
    }

    root.removeAttribute('data-paused');

    const viewportWidth =
      root.querySelector('.ff-marquee__viewport')?.offsetWidth || window.innerWidth;

    let guard = 0;
    while (track.scrollWidth < viewportWidth * 2 && guard < 6) {
      const clone = template.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      guard += 1;
    }

    const shift = template.offsetWidth;
    if (shift > 0) {
      root.style.setProperty('--ff-marquee-shift', '-' + shift + 'px');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ff-marquee]').forEach(initMarquee);
  }

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target?.querySelector?.('[data-ff-marquee]') || event.target;
    if (section?.matches?.('[data-ff-marquee]')) initMarquee(section);
  });

  if (document.fonts?.ready) {
    document.fonts.ready.then(initAll);
  }
})();
